// extracted by mini-css-extract-plugin
export default {"container":"Burger_container__wRfvG","Main":"Burger_Main__RM3Xd"};